import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import DrugNameForm from "./DrugNameForm";

const AddDrugName = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_DrugName_Modal, Loader } = faqProps;
  const [form] = Form.useForm();
  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Drug Names"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addDrugName"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_DrugName_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_DrugName_Modal ? Add_DrugName_Modal : false}
      width={550}
      form={form}
      recordName="drugNameList"
    >
      <DrugNameForm />
    </FormModal>
  );
};

export default AddDrugName;
